import React from 'react';
import { Box } from '@mui/material';
import ReimbursementsSection from '../collaborator/ReimbursementsSection';

const ReimbursementList: React.FC = () => (
    <Box p={3}>
        <ReimbursementsSection />
    </Box>
);

export default ReimbursementList;
